import React from 'react';


class ContentBox extends React.Component{
  render(){
    return (
      <div id={this.props.id}>
        <div className={"content-box-wrapper " + (this.props.className || "")}>
            <div className='text-box-wrap main-content'>
                <div className='text-box-heading'>
                    <p className='uppercase black-roboto'>{this.props.title}</p>
                </div>
                <div className='text-box-p light-roboto'>
                    {this.props.children}
                </div>
            </div>
        </div>
        {this.props.src === "" ? ("") : ( <div className='image-wrapper' style={{backgroundImage: `url(${this.props.src})`}}></div>)}
        
      </div>
    )
  }
}

export default ContentBox;
